<div class="identifier-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="partnerTagsImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <div fxLayout="row" fxFlex="100">
            <app-file-drag-and-drop
              [multiple]="false"
              [generateOutput]="true"
              (fileSelected)="fileSelected($event)"
              [maxSize]="fileMaxSize"
              acceptMime="text/csv"
              fxFlex="100">
            </app-file-drag-and-drop>
          </div>

          <mat-error *ngIf="partnerTagsImportForm.get('fileContent').hasError('backendError')">
            {{partnerTagsImportForm.get('fileContent').getError('backendError')}}
          </mat-error>

          <app-dict
            [label]="'Tag'" [dictType]="'partner_tags'"
            [control]="tagControl"
            [required]="true"
            [multiple]="false"
            [skipKeys]="AUTOMATIC_PARTNER_TAGS"
          ></app-dict>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding" >
              <mat-slide-toggle color="accent" [formControl]="assignTagControl">
                Przypisz tagi zgodnie z importem
              </mat-slide-toggle>
              <span matTooltip="Tag zostanie przypisany Partnerom wskazanym w pliku. Partnerzy, którzy nie występują w raporcie, zachowują dotychczasowe przypisanie tagu."   >
              <mat-icon>info</mat-icon>
            </span>
            </div>
          </div>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" [formControl]="synchronizeTagControl">
                Synchronizuj tagi z importem
              </mat-slide-toggle>
              <span matTooltip="Tag zostanie przypisany Partnerom wskazanym w pliku, a u Partnerów, którzy nie występują w raporcie, zostanie automatycznie odpięty"   >
              <mat-icon>info</mat-icon>
            </span>
            </div>
          </div>

          <div fxLayout="column">
            <div fxLayout="row">
              <h5>Kolejność i nazwy kolumn</h5>
            </div>
            <div fxLayout="row">
              <mat-chip-list>
                <mat-chip  color="accent" selected (click)="copyMessage('PartnerId')">
                  ID Partnera
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!partnerTagsImportFormValid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
    <button (click)="cancel($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>
</div>
